<div class="tw-w-full tw-h-full tw-flex tw-flex-col tw-justify-center tw-items-center tw-bg-white tw-border tw-border-[#E8E8E8] tw-rounded-[10px] md:tw-px-4 lg:tw-px-8">
  <form class="tw-w-full tw-h-fit tw-py-8 tw-px-4" [formGroup]="formGroup">
    <div class="tw-w-full tw-h-fit tw-flex tw-items-center tw-gap-4 tw-mb-8">
      <p class="tw-flex-1 tw-font-poppins tw-font-bold tw-text-lg tw-text-secondary">
        {{ title | translate }}
      </p>
      <div (click)="closeModal()" class="tw-min-w-8 tw-min-h-8 tw-max-w-8 tw-max-h-8 tw-flex tw-justify-center tw-items-center tw-bg-secondary tw-rounded-full tw-cursor-pointer">
        <img class="tw-w-5 tw-h-5 tw-object-contain" src="../../../assets/close-light-icon.svg" />
      </div>
    </div>
    <app-input [formGroup]="formGroup" formControlName="name" [label]="'name' | translate"></app-input>
    <app-input [formGroup]="formGroup" formControlName="email" [label]="'email' | translate" type="email"></app-input>

    <div class="tw-w-full tw-h-2"></div>
    <app-button [disabled]="disableButton" [text]="'save' | translate" [fullWidth]="true" [onButtonClick]="buttonClicked.bind(this)"></app-button>
  </form>
</div>
